import {TemplateRCDataFromRequest} from 'core/RateConfirmation/types';

export const getLogoUrl = (data: TemplateRCDataFromRequest): string => data.companyLogo;
export const getLogoAlt = (data: TemplateRCDataFromRequest): string => data.current_carrier.company_preffix;
